import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

/** Port of cookie-consent.config.ts. The library API is the same outside Angular. */

const cookiesDescription = [
  'We use cookies and similar technologies on this website to ensure its proper functioning and to enhance your browsing experience.',
  'Cookies are small text files placed on your device by your browser when you visit a website. They allow the website to remember certain information about your visit and support secure and efficient operation.',
].join('<br/><br/>');

const cookieConsentConfig: CookieConsent.CookieConsentConfig = {
  categories: {
    necessary: { enabled: true, readOnly: true },
    functional: { enabled: true }, // unused today, present for the future
    analytics: { enabled: true }, // unused today, present for the future
    marketing: {},
  },
  cookie: { sameSite: 'Strict' },
  guiOptions: {
    consentModal: { position: 'middle center' },
  },
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'Cookie and Tracking Disclosure',
          description: cookiesDescription,
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Manage Individual preferences',
        },
        preferencesModal: {
          title: 'Manage cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Accept current selection',
          closeIconLabel: 'Close modal',
          sections: [
            {
              title: 'Strictly Necessary Cookies',
              description:
                'Required for the website to operate correctly, such as enabling secure login, session management, and navigation.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Functional Cookies',
              description:
                'Help us remember basic preferences (e.g., display settings) and provide an improved user experience.',
              linkedCategory: 'functional',
            },
            {
              title: 'Analytical/Performance Cookies (Limited Use)',
              description:
                'May be used in aggregate form to understand general website usage (e.g., number of visitors, pages accessed), but not to identify or profile individual users.',
              linkedCategory: 'analytics',
            },
            {
              title: 'Marketing Cookies',
              description:
                'This website is intended for institutional and professional users only. We do not engage in retail client marketing and therefore do not use targeting or advertising cookies.',
            },
          ],
        },
      },
    },
  },
};

export function runCookieConsent(): void {
  void CookieConsent.run(cookieConsentConfig);
}

export function showCookieConsent(): void {
  CookieConsent.show(true);
}
